export default __webpack_public_path__ + "static/media/btn_ws.5617eae5.jpg";